import React, { useState } from "react";
import { useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import RightTick from "../../Assests/right-tick.svg";
import Loader from "./Loader";
import CancelIcon from "@mui/icons-material/Close";

import "./style.css";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  ListItemText,
  Modal,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function DoneDialog(props: any) {
  const [loading, setLoading] = useState(false);
  const { uploadMasterFileMessage } = useSelector(
    (state: any) => state.InputDataReducers,
  );
  console.log(props, "props.donemessage");

  const handleClosePopup = (e: any) => {
    // window.location.reload();
    props.handleCloseDonePopup();
  };

  return (
    <>
      <Modal open={props.isOpenDone} className="done-modal">
        {props?.data[1] === "master" ? (
          <>
            <DialogContent className="done-modal-body">
              <div>
                <br></br>
                {/* <Loader /> */}

                <h1>Files Uploaded Successfully!</h1>
                <a onClick={handleClosePopup}>Close</a>

                {/* {props?.doneMessage?.toLowerCase()?.includes('successfully') ? <></> : props?.doneMessage?.toLowerCase()?.includes('failed') ? <><h6 className="error-modal-message">{props?.doneMessage}</h6><br/><a onClick={props.handleCloseDonePopup}>Close</a></> : props?.doneMessage} */}
              </div>
            </DialogContent>
          </>
        ) : (
          <>
            <DialogContent
              className="done-modal-body"
              data-keyboard="false"
              data-backdrop="static"
            >
              <div>
                <p>
                  {(props?.doneMessage
                    ?.toLowerCase()
                    ?.includes("gurobi data uploaded successfully!") ||
                    props?.doneMessage?.toLowerCase()?.includes("failed") ||
                    props?.doneMessage
                      ?.toLowerCase()
                      ?.includes("data uploaded successfully!")) && (
                    <>
                      <CancelIcon
                        className="cancel-icon"
                        onClick={handleClosePopup}
                      />

                      {/* <a onClick={handleClosePopup}>Close</a> */}
                    </>
                  )}
                </p>

                <span>
                  {uploadMasterFileMessage
                    ?.split(",")
                    .map((str: any, i: any) => {
                      return <p key={i}>{str}</p>;
                    })}
                </span>
                <br></br>
                {/* <Loader /> */}
                <Box>
                  {/* Baseline Upload Details popup data */}
                  {props?.doneMessage === "Data uploaded successfully" ? (
                    <></>
                  ) : (
                    <>
                      {props?.loading ? (
                        <Box>
                          <div
                            style={{
                              textAlign: "center",
                            }}
                          >
                            <CircularProgress />
                          </div>
                        </Box>
                      ) : (
                        <></>
                      )}
                      <TableContainer>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>File name</TableCell>
                              <TableCell>File status</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {props?.data[0]?.map((item: any) => {
                              if (item?.status?.includes("Successfully")) {
                              }
                              return (
                                <TableRow>
                                  <TableCell>{item.fileName}</TableCell>
                                  <TableCell>{item.status}</TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  )}
                </Box>
                {props?.doneMessage?.toLowerCase()?.includes("successfully") ? (
                  <>
                    <h6>{props?.doneMessage}</h6>
                    <br />
                    {/* <a onClick={handleClosePopup}>Close</a> */}
                  </>
                ) : props?.doneMessage?.toLowerCase()?.includes("failed") ? (
                  <>
                    <h6 className="error-modal-message">
                      {props?.doneMessage}
                    </h6>
                    <br />
                    {/* <a onClick={handleClosePopup}>Close</a> */}
                  </>
                ) : (
                  <>{/* <p> props?.doneMessage</p>  */}</>
                )}
              </div>
            </DialogContent>
          </>
        )}
      </Modal>
    </>
  );
}

export default DoneDialog;
